// @flow

import type { PendingIncomingPayment } from './types';

export function getSafeBoletoBarcode(incomingPayment: PendingIncomingPayment): string {
  const boletoBarcode = incomingPayment['boleto_barcode'];
  if(!boletoBarcode){
    throw new Error('Boleto: no barcode in incoming payment');
  }
  return boletoBarcode;
}
